import { ForOperator, IfOperator, LetOperator } from '@rhtml/operators';
import { Module } from '@rxdi/core';
import { css } from '@rxdi/lit-html';
import { ReactiveUiModule } from '@rxdi/ui-kit';
import { ArticleComponent } from '@rxdi/ui-kit/article';
import { ButtonComponent } from '@rxdi/ui-kit/button';
import { DividerComponent } from '@rxdi/ui-kit/divider';
import { LabelComponent } from '@rxdi/ui-kit/label';
import { ModalModule } from '@rxdi/ui-kit/modal';
import { SpinnerComponent } from '@rxdi/ui-kit/spinner';

import { CategoryFormComponent, CreateCategoryFormComponent } from './components/category';
import { DynamicFormComponent } from './components/dynamic-form';
import { MarkdownReaderModule } from './components/markdown';
import { LitMarkdownEditor } from './components/markdown-editor/mardown-editor.component';
import { UploadService } from './components/uploader';
import { MobileNavigationComponent } from './mobile-navigation/mobile-navigation.component';
import { DateTimeProvider, ModalViewService, ScrollToService } from './services';
import { ShoelaceModule } from './shoelace/shoelace.module';

@Module({
  imports: [
    ModalModule.forRoot(),
    ReactiveUiModule.forRoot({
      palettes: {
        root: css`
          :root {
            --bp-s: 640px;
            --bp-m: 960px;
            --bp-l: 1200px;
            --bp-xl: 1600px;
            --sl-color-sky-600: var(--primary-color);
            --primary-color: #1481ba;
            --primary-dark: #306fcc;
            --secondary-color: #11b5e4;
            --accent-color: #06b6d4;
            --success-color: #10b981;
            --warning-color: #fce765 linear-gradient(90deg, #fedd0b 26.79%, #f6b71b 124.27%);
            --error-color: #ef4444;

            --text-primary: #1a1a1a;
            --text-secondary: #64748b;
            --text-muted: #94a3b8;

            --bg-primary: #ffffff;
            --bg-secondary: #f8fafc;
            --bg-tertiary: #f1f5f9;

            --border-light: #e2e8f0;
            --border-medium: #cbd5e1;
            --border-dark: #94a3b8;

            --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
            --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
            --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
            --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);

            --radius-sm: 4px;
            --radius-md: 8px;
            --radius-lg: 12px;
            --radius-xl: 16px;
            --radius-full: 9999px;
          }
        `,
        danger: css`
          :root {
            --danger-bg-color: #f0506e;
            --danger-color: #fff;
            --danger-border: 1px solid transparent;
            --danger-hover-color: #ee395b;
            --danger-active-color: #ec2147;
          }
        `,
        default: css`
          :root {
            --default-bg-color: transparent;
            --default-color: #222;
            --default-border: 1px solid #e5e5e5;
            --default-hover-color: transparent;
            --default-hover-border: 1px solid #999;
          }
        `,
        primary: css`
          :root {
            --primary-bg-color: #1e87f0;
            // --primary-color: #fff;
            --primary-border: 1px solid transparent;
            --primary-hover-color: #0f7ae5;
            --primary-active-color: #0e6dcd;
          }
        `,
        secondary: css`
          :root {
            --secondary-bg-color: #222;
            // --secondary-color: #fff;
            --secondary-border: 1px solid transparent;
            --secondary-hover-color: #333;
            --secondary-active-color: #000;
          }
        `,
        warning: css`
          :root {
            --warning-bg-color: #faa05a;
            // --warning-color: #fff;
            --warning-border: 1px solid transparent;
            --warning-hover-color: #e19457;
            --warning-active-color: #ef9a56;
          }
        `,
      },
    }),
    MarkdownReaderModule,
    ShoelaceModule,
  ],
  components: [
    ButtonComponent,
    DividerComponent,
    ForOperator,
    IfOperator,
    LetOperator,
    ArticleComponent,
    LabelComponent,
    SpinnerComponent,
    LitMarkdownEditor,
    CategoryFormComponent,
    CreateCategoryFormComponent,
    MobileNavigationComponent,
    DynamicFormComponent,
  ],
  providers: [ScrollToService, ModalViewService, DateTimeProvider, UploadService],
})
export class SharedModule {}
